import React from 'react';
import { Box, Card, Typography } from '@mui/material';
import meestLogo from '../../assets/logoNew.svg';
import notFoundLogo from '../../assets/notFoundLogo.png';

const NotFoundOlx = () => {

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="100vh"
            bgcolor="#f5f5f5"
        >
            <Box
                style={{
                    width: '460px',
                    height: '150px',
                    backgroundColor: '#005096',
                    position: 'absolute',
                    top: 0,
                }}
            />
            <Card style={{ width: 420, height: '94%', display: 'flex', flexDirection: 'column', alignItems: 'center', borderRadius: '15px', padding: '20px', zIndex: '10' }}>
                <Box display="flex" justifyContent="center" mt={2} mb={30}>
                    <img src={meestLogo} alt="Meest Logo" style={{ height: '40px' }} />
                </Box>
                <Box display="flex" justifyContent="center" mb={4}>
                    <img src={notFoundLogo} alt="Not Found Logo" style={{ height: '120px' }} />
                </Box>
                <Typography variant="h6" gutterBottom>
                    Упс! Щось пішло не так!
                </Typography>
                <Box width="300px">
                    <Typography variant="body1" color="textSecondary" align="center">
                        По Вашому запиту не вдалося сформувати OLX оплату, спробуйте пізніше
                    </Typography>
                </Box>
            </Card>
        </Box>
    );
}

export default NotFoundOlx;




